import React, { useEffect, useState } from "react";
import "./DashDocPreview.scss";
import logo from "../../Assets/logo/logo.svg";
import { GiCheckMark } from "react-icons/gi";
import { Link, useNavigate } from "react-router-dom";
import Button from "../Buttons/Button";

const DashDocPreview = ({ courseData, id,toggleModal }) => {
  const navigator = useNavigate();
  // let price = 0;  

  const [course, setCourse] = useState({});
  // const [isId, setIsId] = useState(null);

  useEffect(() => {
    setCourse(courseData);
    // setIsId(id);
  }, [courseData, id]);

  // if (course && Object.keys(course).length > 0) {
  //   if (isId) {
  //     if (id === "spsn") {
  //       price = course.studyNotes.price;
  //     } else if (id === "pp") {
  //       price = course.practicePapers.price;
  //     } else if (id === "qb") {
  //       price = course.questionBank.price;
  //     }
  //   } else {
  //     price =
  //       course?.type === "Special Study Notes"
  //         ? course?.studyNotes?.price
  //         : course?.type === "Practice Papers"
  //         ? course?.practicePapers?.price
  //         : course?.type === "Question Bank"
  //         ? course?.questionBank?.price
  //         : "N/A";
  //   }
  // }

  return (
    <div className="doc-preview-container mb-5">
      <div className="both-pages">
        {/* Page 1 */}
        <div className="page-one">
          <div className="earth-systems">
            <div className="locked-pdf">
              <h1>Earth Systems Overview</h1>
              <p>
                Earth Systems is a comprehensive and multidisciplinary field of study that delves into various aspects of the Earth and its interactions with its environment. This field encompasses five major areas of study, each focusing on different components of the Earth and its systems.
              </p>

              <h2>Major Areas of Study</h2>
              <ul>
                <li>
                  <h3>Astronomy</h3>
                  <p>
                    This area focuses on the study of celestial bodies and phenomena beyond the Earth's atmosphere. It examines objects such as stars, planets, comets, galaxies, and other cosmic entities. Astronomy seeks to understand the origins, structures, and behaviors of these celestial bodies, as well as how they affect the Earth. It plays a crucial role in expanding our knowledge about the universe and the place of our planet within it.
                  </p>
                </li>
                <li>
                  <h3>Meteorology</h3>
                  <p>
                    Meteorology is the study of the Earth's atmosphere, primarily concerned with weather patterns and atmospheric conditions. Meteorologists study the factors that drive weather changes, such as temperature, pressure, wind patterns, and humidity. Their work is essential in predicting weather and understanding climate patterns, which have significant impacts on agriculture, natural disasters, and daily life.
                  </p>
                </li>

                <li>
                  <h3>Geology</h3>

                  <p>
                    Geology is the study of the Earth's solid materials, including rocks, minerals, and the processes that shape the Earth’s surface. Geologists investigate the formation of mountains, valleys, and other geological features. They also study processes like plate tectonics, earthquakes, and volcanic activity. By understanding the Earth's geological history, geologists can learn about the planet's past and predict future geological events.
                  </p>
                </li>
                <li>
                  <h3>Oceanography</h3>
                  <p>
                    Oceanography explores the Earth's oceans, focusing on the physical, chemical, and biological properties of the seas and how they interact with the atmosphere and the Earth's surface. Oceanographers study ocean currents, marine life, and the chemical composition of seawater. Their research helps to better understand the Earth's climate, as the oceans play a crucial role in regulating weather patterns and supporting diverse ecosystems.
                  </p>
                </li>
                <li>
                  <h3>Environmental Science</h3>
                  <p>
                    Environmental Science is the study of how organisms interact with their surroundings, including their impact on natural ecosystems. This field explores issues like pollution, conservation, and the sustainability of natural resources. Environmental scientists work to understand how human activity affects the environment and develop strategies to mitigate damage and protect biodiversity for future generations.
                  </p>
                </li>

              </ul>
            </div>


            <div className="locked-pdf-div">
              <div className="locked-pdf-div-content">
                <div className="locked-pdf-div-content-flex">
                  <div className="locked-pdf-price-dash">
                    Get Access - ${courseData?.tempCourse.coursePrice}
                  </div>
                  <button
                    type="submit"
                    className="my-1  btn buy-locked-dash"
                    onClick={toggleModal}
                  >
                    View Full Document
                  </button>
                  <div>
                    <ul className="locked-pdf-div-content-list-dash">
                      <li>Lifetime Access</li>
                      <li>No Hidden Charges</li>
                    </ul>
                  </div>
                </div>

                <div className="locked-pdf-div-content-bottom-dash">
                  <p>🎓 Prepared by Former Alumni</p>
                  <p>✅ 100% Satisfaction Guarantee</p>
                </div>
              </div>

            </div>

          </div>
        </div>

        {/* Page 2 */}
        {/* <div className="page-two">
          <div className="blur-overlay">
            <div className="overlay-content">
              <h1>Export Study Material</h1>
              <h1> ${courseData?.tempCourse?.coursePrice || 0}</h1>
              <p>This course examines number of theories of personality,</p>
              <Button
                type="submit"
                text="Buy Now"
                varient="linear-gradient-primary"
                className=" my-1 px-4 py-3"
                onClick={() => {
                  navigator("/dashboard/paynow", {
                    state: { ...course, price: courseData?.tempCourse.coursePrice || 0 },
                  });
                }}
              />
              <p className="mb-4">All Rights Reserved to DoubtQ !</p>

              <div className="overlay-content-list">
                <div className="overlay-content-item">
                  <GiCheckMark className="overlay-content-item-icon" />
                  <p>100% satisfaction guarantee</p>
                </div>
                <div className="overlay-content-item">
                  <GiCheckMark className="overlay-content-item-icon" />
                  <p>Accurate Study Notes</p>
                </div>
                <div className="overlay-content-item">
                  <GiCheckMark className="overlay-content-item-icon" />
                  <p>Available in PDF</p>
                </div>
                <div className="overlay-content-item">
                  <GiCheckMark className="overlay-content-item-icon" />
                  <p>No Additional Costs</p>
                </div>
              </div>
            </div>
          </div>
          <div className="position-absolute bottom-0 end-0 p-3">
            <p>Page 2</p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default DashDocPreview;
